"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setName = exports.networkRecieveStartLerpToXY = exports.removeDead = exports.updateAll = exports.killAll = exports.kill = exports.moveToXY = exports.create = exports.findByMultiIdSafe = exports.findByMultiId = exports.getAll = exports.mouseCursorUpdateTime = void 0;
var crokinoleCamera_sidecar_1 = require("@crokinole/main/crokinoleCamera-sidecar");
var spritesUiCursors_1 = require("@crokinole/recyclers/spritesUiCursors");
var crokinoleLayers_sidecar_1 = require("@crokinole/scene/crokinoleLayers-sidecar");
var echoFonts_sidecar_1 = require("@echo/echoFonts-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var entitiesUtils_sidecar_1 = require("@entities/entitiesUtils-sidecar");
var imports_1 = require("@lib/imports");
var spring_sidecar_1 = require("@lib/spring-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var stevieTexts2_sidecar_1 = require("@uiParts/stevieTexts2-sidecar");
var voyageColors_sidecar_1 = require("@voyage/scene/voyageColors-sidecar");
// TODO: make extension version of this
var namespace = 'multiplayer-cursors-crokinole';
exports.mouseCursorUpdateTime = 1 / 20;
var objs = [];
function getAll() {
    return objs;
}
exports.getAll = getAll;
function findByMultiId(multiId) {
    return imports_1.l.find(getAll(), function (c) { return c.multiId == multiId; }) || null;
}
exports.findByMultiId = findByMultiId;
function findByMultiIdSafe(multiId) {
    var cur = findByMultiId(multiId);
    if (!cur) {
        cur = create(multiId);
    }
    return cur;
}
exports.findByMultiIdSafe = findByMultiIdSafe;
function create(multiId) {
    var color = voyageColors_sidecar_1.voyageColors.red;
    console.log(namespace, 'create', multiId);
    // TODO: use new text rendering
    var textCursor = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().uiGame);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(textCursor, 4);
    stevieTexts2_sidecar_1.stevieTexts2.setText(textCursor, '' + multiId);
    var textSelected = stevieTexts2_sidecar_1.stevieTexts2.create(echoFonts_sidecar_1.echoFonts.getData().font4, 0, 0, crokinoleLayers_sidecar_1.crokinoleLayers.getLayers().uiGame);
    stevieTexts2_sidecar_1.stevieTexts2.setScale(textSelected, 4);
    stevieTexts2_sidecar_1.stevieTexts2.setText(textSelected, '' + multiId);
    var obj = {
        id: -1,
        idLoaded: -1,
        multiId: multiId,
        isDead: false,
        eType: 'voy-misc',
        // imageCursor: imageCursor,
        // imageSelected,
        //crewSelected: null,
        textCursor: textCursor,
        textSelected: textSelected,
        springX: spring_sidecar_1.spring.create(),
        springY: spring_sidecar_1.spring.create(),
        // springTileX: spring.create(),
        // springTileY: spring.create(),
        name: 'Unknown',
        //pickMode: 'normal',
        //selectedSpell: null,
        x: 0,
        y: 0,
        updateTimer: 0,
        hideTimer: 0,
        isHidden: false,
        color: color,
    };
    objs.push(obj);
    spring_sidecar_1.spring.setDef(obj.springX, spring_sidecar_1.spring.defTight());
    spring_sidecar_1.spring.setDef(obj.springY, spring_sidecar_1.spring.defTight());
    // spring.setDef(obj.springTileX, spring.defTight())
    // spring.setDef(obj.springTileY, spring.defTight())
    return obj;
}
exports.create = create;
function moveToXY(obj, x, y) {
    obj.x = x;
    obj.y = y;
    stevieTexts2_sidecar_1.stevieTexts2.moveTo(obj.textCursor, x + 32, y);
}
exports.moveToXY = moveToXY;
function kill(obj) {
    obj.isDead = true;
}
exports.kill = kill;
function killAll() {
    imports_1.l.forEach(objs, function (c) {
        kill(c);
    });
    removeDead();
}
exports.killAll = killAll;
function updateAll() {
    imports_1.l.forEach(objs, function (c) {
        update(c);
    });
    removeDead();
}
exports.updateAll = updateAll;
function removeDead() {
    entitiesUtils_sidecar_1.entitiesUtils.removeDead(objs, function (c) {
        // c.imageCursor.destroy()
    });
}
exports.removeDead = removeDead;
function update(obj) {
    var dt = common_sidecar_1.common.getUpdateDelta();
    obj.updateTimer += dt;
    obj.hideTimer += dt;
    if (obj.hideTimer > 5) {
        obj.isHidden = true;
    }
    else {
        obj.isHidden = false;
    }
    // Is this us?
    if (obj.multiId === websockets_sidecar_1.websockets.getMultiId() || obj.multiId === 0) {
        obj.isHidden = true;
    }
    // obj.imageCursor.visible = !obj.isHidden
    stevieTexts2_sidecar_1.stevieTexts2.setVisible(obj.textCursor, !obj.isHidden);
    spring_sidecar_1.spring.update(obj.springX, dt);
    spring_sidecar_1.spring.update(obj.springY, dt);
    // spring.update(obj.springTileX, dt)
    // spring.update(obj.springTileY, dt)
    if (!obj.isHidden) {
        // crokinoleCamera.setCameraXY(-200, -200)
        // // console.log(
        // //   'host status',
        // //   websockets.getIsHost(),
        // //   websockets.getHostId(),
        // //   websockets.getMultiId(),
        // // )
        // if (websockets.getIsHost()) {
        //   crokinoleCamera.setCameraXY(-100, -100)
        // }
        var co = crokinoleCamera_sidecar_1.crokinoleCamera.getCameraXY();
        moveToXY(obj, obj.springX.position - co.cx, obj.springY.position - co.cy);
        var cursor = spritesUiCursors_1.spritesUiCursors.getNext(obj.springX.position - co.cx, // + voyageCamera.get().cameraX,
        obj.springY.position - co.cy, // + voyageCamera.get().cameraY,
        sprites_sidecar_1.sprites.diveEffectsCursorMultiplayerPointer[0]);
        cursor.tint = obj.color;
        // TODO: write text into gamespace
        // rogueMonofont.writeAbsolute(
        //   obj.springX.position + 32,
        //   obj.springY.position,
        //   obj.name,
        // )
        // if (obj.pickMode === 'normal') {
        //   let hoveredTile = spritesCursors.getNext(
        //     obj.springTileX.position,
        //     obj.springTileY.position,
        //     sprites.diveEffectsCursorMultiplayer[0],
        //   )
        //   hoveredTile.tint = obj.color
        //   let cursor = spritesCursors.getNext(
        //     obj.springX.position,
        //     obj.springY.position,
        //     sprites.diveEffectsCursorMultiplayerPointer[0],
        //   )
        //   cursor.tint = obj.color
        // }
        // if (obj.pickMode === 'cast') {
        //   if (obj.selectedSpell === null) {
        //     console.warn(namespace, 'no spell selected')
        //     // TODO: fix this
        //     // obj.selectedSpell = diveSpell_firewall
        //   } else {
        //     let tHereI = diveTilemap.convertXtoI(obj.springX.position)
        //     let tHereJ = diveTilemap.convertYtoJ(obj.springY.position)
        //     //let tHereI = obj.springTileX.position
        //     //let tHereJ = obj.springTileY.position
        //     let activate = false
        //     let spell = obj.selectedSpell
        //     let { x: cursorTileX, y: cursorTileY } = diveTilemap.convertIJtoXY(
        //       tHereI,
        //       tHereJ,
        //     )
        //     let cursorOptions: ISpellCursorOptions = {
        //       cursorI: tHereI,
        //       cursorJ: tHereJ,
        //       cursorTileX,
        //       cursorTileY,
        //       activate,
        //     }
        //     let isValid = spell.spell_cursor(cursorOptions)
        //   }
        // }
    }
}
// TODO: new dive method
function networkRecieveStartLerpToXY(obj, x, y) {
    // console.log(namespace, 'networkRecieveStartLerpToXY', obj.id)
    obj.springX.target = x;
    obj.springY.target = y;
    // let tx = diveTilemap.convertXtoI(x)
    // let ty = diveTilemap.convertYtoJ(y)
    // let tileXY = diveTilemap.convertIJtoXY(tx, ty)
    // obj.springTileX.target = tileXY.x
    // obj.springTileY.target = tileXY.y
    obj.updateTimer = 0;
    obj.hideTimer = 0;
}
exports.networkRecieveStartLerpToXY = networkRecieveStartLerpToXY;
function setName(obj, name) {
    obj.name = name;
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.textCursor, name);
    stevieTexts2_sidecar_1.stevieTexts2.setText(obj.textSelected, name);
}
exports.setName = setName;
